import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export interface BtnOption {
  title: string | JSX.Element;
  className?: string;
  onClick: () => void;
}

interface Props {
  options: BtnOption[];
  icon: JSX.Element;
}

/**
 * Button menu component
 */
export default function ButtonMenu({ options, icon }: Props) {
  return (
    <Menu as="div" className={`min-w-max relative p-1`}>
      <div>{icon}</div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute mt-2 min-w-max origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {options.map((opt: BtnOption, index: number) => (
            <div className="px-1 py-1" key={index}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    className={`${opt.className} ${
                      active ? 'bg-blue-600 text-white' : 'text-gray-900'
                    } group flex w-full items-center rounded-md p-1 text-sm`}
                    onClick={opt.onClick}
                  >
                    {opt.title}
                  </button>
                )}
              </Menu.Item>
            </div>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
